import React from "react";
import { Card } from "react-bootstrap";

const TrainingCard = ({ title, subtitle, body }) => {
  const buildBody = (body) => {
    if (Array.isArray(body)) {
      const listItems = body.map((item, index) => <li key={index}>{item}</li>);
      return <ul>{listItems}</ul>;
    } else {
      return body;
    }
  };
  return (
    <Card>
      <Card.Header>{title}</Card.Header>
      <Card.Body>
        {subtitle && <Card.Title>{subtitle}</Card.Title>}
        <Card.Text as="div">{buildBody(body)}</Card.Text>
      </Card.Body>
    </Card>
  );
};

export default TrainingCard;
